import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { KindService } from 'app/services/models/kind.service';
import { ProcedureService } from 'app/services/models/procedure.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-procedure-dialog',
  templateUrl: './procedure-dialog.component.html',
  styleUrls: ['./procedure-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProcedureDialogComponent implements OnInit {
  @Input() data;
  form: FormGroup;
  kinds: any[] = [];
  procedure: any;
  constructor(
    public ngbModal: NgbActiveModal,
    private fb: FormBuilder,
    private kindService: KindService,
    private procedureService: ProcedureService,
    private toastrService: ToastrService
  ) { }

  async ngOnInit() {
    this.initializeForm(); // Formu hemen başlat
    if (this.data) {
      const proc = await this.procedureService.getByIdProcedure(this.data);
      this.procedure = proc;
      this.form.patchValue({
        name: this.procedure.name,
        kindId: this.procedure.kindId,
        status: this.procedure.status,
        description: this.procedure.description
      });
    }

    await this.getAllKinds();
  }

  isDisabled() {
    return this.data === 1 || this.data === 2 || this.data === 3 || this.data === 4 || this.data === 5;
  }

  initializeForm() {
    this.form = this.fb.group({
      name: ['', Validators.required],
      kindId: [null, Validators.required],
      status: [true],
      description: ['']
    });
  }

  async getAllKinds() {
    const data = await this.kindService.getAllKinds('', 0, 100, 13);
    this.kinds = data.types;
  }

  closeModal() {
    this.ngbModal.close('Modal Kapatıldı.');
  }

  async onSubmit() {
    if (this.form.valid) {
      console.log(this.form.value);

      if (this.data) {
        const data = await this.procedureService.updateProcedure(this.procedure.id, this.form.value.name, this.form.value.kindId, this.form.value.description, this.form.value.status);
        if (data.status) {
          this.closeModal();
          this.toastrService.success(data.message);
          this.procedureService.sendEvent(true);
        } else {
          this.toastrService.error(data.message);
        }
      } else {
        const data = await this.procedureService.createProcedure(this.form.value.name, this.form.value.description, this.form.value.kindId, this.form.value.status);
        if (data.status) {
          this.closeModal();
          this.toastrService.success(data.message);
          this.procedureService.sendEvent(true);
        } else {
          this.toastrService.error(data.message);
        }
      }
    }
  }
}